import MailIcon from './component'

export default MailIcon
